import React from 'react'
import styled from '@emotion/styled'
import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import useIsImageloaded from '@vio/atlas/hooks/useIsImageloaded'
import {cssTheme} from '@vio/atlas/themes'

interface Props {
  /** The language in which the store logos should render */
  lang?: string
  /** The URL pointing to the Apple App Store page */
  appleAppStoreUrl?: string
  /** The URL pointing to the Google Play page */
  googlePlayUrl?: string
}

interface BadgeProps {
  lang?: string
  height?: number
}

const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s300};
`

const FlexNoStyleLink = styled(NoStyleLink)`
  display: flex;
`

const appleAppStoreLangMap = {
  'zh-HK': 'zh',
  'zh-TW': 'zh'
} as {[key: string]: string}

export const AppleAppStoreBadge = ({lang = 'en', height = 40}: BadgeProps) => {
  const supportedLang = appleAppStoreLangMap[lang] || lang

  const imageSrc = `https://i.fih.io/appStoreBadges/appleAppStore/${supportedLang}.svg`
  const fallbackSrc = 'https://i.fih.io/appStoreBadges/appleAppStore/en.svg'

  const {isErrored} = useIsImageloaded(imageSrc)

  return (
    <img
      src={isErrored && fallbackSrc ? fallbackSrc : imageSrc}
      alt={'Apple App Store badge'}
      height={height}
    />
  )
}

export const GooglePlayBadge = ({lang = 'en', height = 40}: BadgeProps) => {
  const imageSrc = `https://i.fih.io/appStoreBadges/googlePlay/${lang}.svg`
  const fallbackSrc = 'https://i.fih.io/appStoreBadges/googlePlay/en.svg'

  const {isErrored} = useIsImageloaded(imageSrc)

  return (
    <img
      src={isErrored && fallbackSrc ? fallbackSrc : imageSrc}
      alt={'Google Play badge'}
      height={height}
    />
  )
}

export const AppButtonsWidget = ({
  lang,
  appleAppStoreUrl,
  googlePlayUrl
}: Props) => (
  <ButtonsWrapper>
    <FlexNoStyleLink href={appleAppStoreUrl}>
      <AppleAppStoreBadge lang={lang} />
    </FlexNoStyleLink>
    <FlexNoStyleLink href={googlePlayUrl}>
      <GooglePlayBadge lang={lang} />
    </FlexNoStyleLink>
  </ButtonsWrapper>
)
